import { useEffect } from 'react';
import { type NodeRoomV2, useGetRoomsForUserQuery } from '../../services/room';
import { getLogger } from '../../libs/logger';

export { type NodeRoomV2 };

const logger = getLogger('useRooms');

type UseRoomsProps = {
  userId: string;
  institutionId: number | null;
  skip?: boolean;
};

type UseRoomsReturnType = {
  rooms: NodeRoomV2[] | undefined;
  isLoading: boolean;
  isError: boolean;
};

/**
 * Get the rooms of a provider.
 */
export const useRooms = ({
  skip = false,
}: UseRoomsProps): UseRoomsReturnType => {
  const {
    currentData: gqlData,
    isLoading,
    error,
  } = useGetRoomsForUserQuery(undefined, {
    skip,
  });

  const rooms = gqlData?.Room?.getRoomsForUser?.edges || [];

  useEffect(() => {
    if (error) {
      logger.error('Failed to get rooms');
    }
  }, [error]);

  return {
    rooms,
    isLoading,
    isError: error != null,
  };
};
